import { useMap } from "@vis.gl/react-maplibre";
import { useLayoutEffect } from "react";

import { getAliveMap } from "@ryde/controls";

import { registerMapLibreMissingStyleImageResolver } from "./maplibre-missing-style-image.utils";

/**
 * MapLibre v6 asks for `icon-image` during the first style evaluation. `onLoad` is already too late
 * for that pass, so the resolver must be on the map as soon as the instance exists — before sibling
 * symbol layers mount in `useEffect`.
 *
 * `setMissingStyleImageResolver` stores the callback on the Map (`_missingStyleImageResolver`) and
 * the current Style copies it in its constructor, so a later tiles `setStyle` keeps the resolver.
 * Runtime images are dropped with the old style; those are re-baked on `style.load`, not the resolver.
 */
export const useMapLibreMissingStyleImages = (): void => {
  const { current: mapRef } = useMap();

  useLayoutEffect(() => {
    const map = getAliveMap(mapRef);
    if (!map) {
      return;
    }
    registerMapLibreMissingStyleImageResolver(map);
  }, [mapRef]);
};
